import {
  Component,
  ChangeDetectionStrategy,
  DestroyRef,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { TrackingMapsRenderService } from '../tracking-maps-render.service';
import { AuthFacade } from '../../../store';
import { TransportMode } from '../../../common/constants';
import { MapPoint, MapStop, MapTrackingPoints } from '../../../common/models';
import { MapComponent } from './map/map.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-tracking-map',
  imports: [CommonModule, TranslateModule],
  templateUrl: './tracking-map.component.html',
  styleUrls: ['./tracking-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingMapComponent implements OnInit {
  @Input() trackingTransportMode: TransportMode;
  @Input() set mapData(mapData: MapTrackingPoints<MapStop, MapPoint>) {
    this.mapData$.next(mapData);
  }

  @ViewChild('mapContainer', { read: ViewContainerRef, static: true })
  mapContainerRef: ViewContainerRef;

  private mapData$ = new BehaviorSubject<MapTrackingPoints<MapStop, MapPoint>>(null);

  constructor(
    private trackingMapsRenderService: TrackingMapsRenderService,
    public authFacade: AuthFacade,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.authFacade.mapsPluginAccepted$,
      this.trackingMapsRenderService.isGoogleMapApiScriptAppended$,
      this.mapData$,
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([accepted, scriptAppended, mapData]: [boolean, boolean, MapTrackingPoints<MapStop, MapPoint>]) => {
        if (!accepted || !scriptAppended || !mapData) {
          this.mapContainerRef.clear();
          return;
        }

        const component = this.trackingMapsRenderService.render<MapComponent>(this.mapContainerRef, MapComponent);
        component.instance.trackingTransportMode = this.trackingTransportMode;
        component.instance.mapData = mapData;
      });
  }
}
